import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";

export class PointagePause {
    @AutoMap()
    Debut!: Temporal.PlainDateTime;
    @AutoMap()
    Fin!: Temporal.PlainDateTime;

    public constructor(init?: Partial<PointagePause>) {
        Object.assign(this, init);
    }
}